<template>
  <v-row class="mx-auto">
    <v-col class="pb-0" cols="12">
      <div class="display-1 font-weight-light mt-4 text-left">Tem certeza que deseja apagar os elementos selecionados?</div>
      <div id="total-registros-expurgo" class="display-1 font-weight-light mt-4 text-left">
        Total Registros:
        <strong>{{ totalRegistro | parseNumberToIntegerBR }}</strong>
      </div>
    </v-col>
  </v-row>
</template>
<script>
  export default {
    props: {
      itemsResumo: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        totalRegistro: ''
      };
    },

    methods: {
      totalRegistros() {
        let soma = 0;
        this.itemsResumo.forEach(function (item) {
          soma = soma + parseInt(item.numero_registros);
        });
        return soma;
      }
    },

    watch: {
      itemsResumo() {
        this.totalRegistro = this.totalRegistros();
      }
    }
  };
</script>
<style>
  .listaResumo {
    font-size: 1rem !important;
    font-weight: normal !important;
  }
</style>